import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable()
export class GeographyService {

  constructor(private readonly http: HttpClient) { }

  provinciafindAll():Observable<any>{
    const params = new HttpParams().set('funcion', 'provinciafindAll');
    return this.http.get(`${environment.url.gestionGeografia}`, { params });
  }
  provinciaFindByProCodigo(proCodigo:number):Observable<any>{
    const params = new HttpParams().set('funcion', 'provinciaFindByProCodigo').set('proCodigo',''+proCodigo);
    return this.http.get(`${environment.url.gestionGeografia}`, { params });
  }

  findlocalidadByLocCod(locCod1:number):Observable<any>{
    const params = new HttpParams().set('funcion', 'findlocalidadByLocCod').set('locCod1',''+locCod1);
    return this.http.get(`${environment.url.gestionGeografia}`, { params });
  }

  findAlllocalidadByProvincia(proCodigo:number):Observable<any>{
    const params = new HttpParams().set('funcion', 'findAlllocalidadByProvincia').set('locProvin',''+proCodigo);
    return this.http.get(`${environment.url.gestionGeografia}`, { params });
  }

}
